import { render, staticRenderFns } from "./CheckBoxComponent.vue?vue&type=template&id=77552909&scoped=true&"
import script from "./CheckBoxComponent.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxComponent.vue?vue&type=style&index=0&id=77552909&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77552909",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCheckbox,VSheet})
